import type { GetButtonStyle } from './types'

export const getPreviousButtonStyle: GetButtonStyle = (customHeaderCount) =>
  customHeaderCount === 1 ? { visibility: 'hidden' } : null

export const getNextButtonStyle: GetButtonStyle = (customHeaderCount) =>
  customHeaderCount === 0 ? { visibility: 'hidden' } : null
